import { render } from "./MedeaMix.vue?vue&type=template&id=72504026&scoped=true"
import script from "./MedeaMix.vue?vue&type=script&lang=js"
export * from "./MedeaMix.vue?vue&type=script&lang=js"

import "./MedeaMix.vue?vue&type=style&index=0&id=72504026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72504026"]])

export default __exports__